import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "onhold",
  "use": "onhold-usage",
  "viewBox": "0 0 18.33 18.33",
  "content": "<symbol viewBox=\"0 0 18.33 18.33\" id=\"onhold\"><title>ONHOLDAsset 14</title><path d=\"M9.17,0a9.17,9.17,0,1,0,9.17,9.17A9.17,9.17,0,0,0,9.17,0Zm0,16.33a7.17,7.17,0,1,1,7.17-7.17A7.17,7.17,0,0,1,9.17,16.33Z\" /><rect x=\"6.04\" y=\"5.67\" width=\"2\" height=\"7\" rx=\"0.61\" ry=\"0.61\" /><rect x=\"10.29\" y=\"5.67\" width=\"2\" height=\"7\" rx=\"0.59\" ry=\"0.59\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol